import { render, staticRenderFns } from "./ScrollBody.vue?vue&type=template&id=6cd3f577&scoped=true&"
import script from "./ScrollBody.vue?vue&type=script&lang=js&"
export * from "./ScrollBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd3f577",
  null
  
)

export default component.exports